import EnumClass from "./EnumClass";

export default class ActionStatus extends EnumClass{
  static Rascunho = 1;
  static EmAprovacaoComercial = 2;
  static Reprovada = 3;
  static AprovacaoMarketing = 4;
  static ReprovadaMarketing = 5;
  static EmProcessodePagamento = 6;
  static Cancelada = 7;
  static Concluido = 8;

  static _getNameProperty(name:string):string{
    switch(name){
      case "Rascunho": return "Rascunho";
      case "EmAprovacaoComercial": return "Em Aprovação Comercial";
      case "Reprovada": return "Reprovada";
      case "AprovacaoMarketing": return "Aprovação Marketing";
      case "ReprovadaMarketing": return "Reprovada Marketing";
      case "EmProcessodePagamento": return "Em processo de pagamento";
      case "Cancelada": return "Cancelada";
      case "Concluido": return "Concluído";
      default: return name;
    }
  }
}